import { useEffect, useRef, useState } from 'react';

const KPI_SINGLE_COLUMN_BREAKPOINT = 620;
const KPI_COMPACT_BREAKPOINT = 1120;

export function useSummaryDom() {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const [canvasWidth, setCanvasWidth] = useState(0);

  useEffect(() => {
    if (!rootRef.current || typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      setCanvasWidth(entry.contentRect.width);
    });

    observer.observe(rootRef.current);
    return () => observer.disconnect();
  }, []);

  const isKpiSingleColumn = canvasWidth > 0 && canvasWidth < KPI_SINGLE_COLUMN_BREAKPOINT;
  const isKpiCompact = !isKpiSingleColumn && canvasWidth > 0 && canvasWidth < KPI_COMPACT_BREAKPOINT;
  const kpiGridColumnsClass = isKpiSingleColumn ? 'grid-cols-1' : 'grid-cols-3';

  return {
    refs: { rootRef },
    computed: { isKpiSingleColumn, isKpiCompact, kpiGridColumnsClass, canvasWidth },
  };
}
